import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal, Space, Switch, Tooltip, message } from 'antd';
import { ConfirmAction } from '../../../molecules/confirm/ConfirmAction';
import { HOME } from '../../../../constants/define/translation';
import {
  HomeWidgetsRecord,
  postUpdateHomeWidgetsRepository,
} from '../../../../repository/mytm/home/homeWidgetsRepository';
import { HomeWidgetStatus } from '../../../../types/home';
import { postLoginRepository } from '../../../../repository/mytm/auth/loginRepository';
import { UserContext } from '../../../../repository/context/userContext';
import { MESSAGE_ERROR } from '../../../../constants/message';
import { btnActive } from '../../../../styles';

interface ActionsColumnProps {
  record: HomeWidgetsRecord;
  onRefresh: () => void;
}

export default React.memo((props: ActionsColumnProps) => {
  const { t } = useTranslation(HOME);
  const { record, onRefresh } = props;
  const userContext = useContext(UserContext);

  const [showHideLoading, setShowHideLoading] = useState(false);

  const recordActive = record.status === HomeWidgetStatus.ACTIVE;

  const onShowHideCard = () => {
    const payload = { ...record, show: !record.show };
    delete payload.index;
    Modal.confirm({
      title: t('popup.title'),
      okText: t('popup.okBtn'),
      cancelText: t('popup.cancelBtn'),
      icon: <ExclamationCircleOutlined />,
      content: record.show ? (
        <ConfirmAction
          textConfirmAction={t('popup.hide')}
          isConfirmPassword
          textConfirmPassword={t('popup.confirmPassword')}
        />
      ) : (
        <ConfirmAction
          textConfirmAction={t('popup.show')}
          isConfirmPassword
          textConfirmPassword={t('popup.confirmPassword')}
        />
      ),
      onOk() {
        setShowHideLoading(true);
        const inputPasswordNode = document.getElementById('inputPasswordForConfirm');
        const password = (inputPasswordNode as any).value;
        const updateFunc = () => {
          postUpdateHomeWidgetsRepository(record.id, payload)
            .then(r => {
              onRefresh();
              setShowHideLoading(false);
            })
            .catch(e => {
              setShowHideLoading(false);
              message.error(e?.errorMessage || t('message.updateHomeExplorerError'));
            });
        };

        if (!userContext.user?.email || userContext.user?.email === '') {
          setShowHideLoading(false);
          message.error(MESSAGE_ERROR.M02);
        } else {
          postLoginRepository({
            email: userContext.user?.email,
            password,
          })
            .then(() => {
              updateFunc();
            })
            .catch((e: any) => {
              setShowHideLoading(false);
              message.error(e?.errorMessage || t('message.updateHomeExplorerError'));
            });
        }
      },
    });
  };

  return (
    <StyledContainer>
      <Space size="small">
        {recordActive && (
          <Tooltip title={record.show ? t('table.tooltip.hide') : t('table.tooltip.show')}>
            <Switch
              checked={!!record.show}
              onChange={onShowHideCard}
              disabled={showHideLoading}
              loading={showHideLoading}
            />
          </Tooltip>
        )}
      </Space>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  ${btnActive}
`;
